<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <!-- Unpublish Resource Modal -->
    <div class="modal fade" id="unpublishResourceModal" tabindex="-1" role="dialog" aria-labelledby="unpublishResourceModalLabel" aria-hidden="true" style="z-index: 999999;">
      <div class="modal-dialog modal-lg" role="document" style="max-width: 750px;">
        <div class="modal-content">
          <div class="modal-header border-0" style="display: flex; justify-content: flex-end; padding: 15px 20px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Cancel" style="position: static; margin-left: auto;">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" style="padding: 0 30px 30px 30px;">
            <h4 id="unpublishResourceModalLabel" style="color: #0051BA; font-weight: bold; margin-bottom: 20px;">Unpublish Resource</h4>
            <p style="font-size: 16px; line-height: 1.6; margin-bottom: 25px;">
              If you proceed, the resource will be unpublished from the registry in which it is published.
            </p>

            <div class="d-flex gap-2 pt-2" style="gap: 10px;">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <button
                type="button"
                class="btn btn-registry"
                @click="confirmUnpublish"
                :style="{
                  opacity: selectedUnpublishUrl ? 1 : 0.7,
                  cursor: selectedUnpublishUrl ? 'pointer' : 'not-allowed',
                }">
                Unpublish
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="card shadow mb-3">
        <h2 class="card-header-resource-light-text text-center">{{ existingData.resource.name }}</h2>
        <p class="text-center"><small>Resource ID # {{ existingData.resource.id }}</small></p>

        <div class="card shadow mb-4 mt-4">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h3 class="color-registry-dark mb-4">Registries Where Published</h3>
              </div>
              <div class="col-12">
                <div class="card">
                  <table v-if="associatedIrrs.length" class="table table-sm table-hover table-borderless" style="table-layout: fixed; width: 100%;">
                    <thead class="border-bottom">
                      <tr>
                        <th class="larger pl-3" scope="col" style="width: 33%;">Registry</th>
                        <th class="larger" scope="col" style="width: 33%;">Status</th>
                        <th class="larger" scope="col" style="width: 34%;">&nbsp;</th> <!-- Column for buttons -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="assocIrr in associatedIrrs">
                        <th class="pl-3"><a :href="'/irr/' + assocIrr.id + '/'" data-bs-toggle="tooltip" data-bs-placement="right" :title="assocIrr.description">{{assocIrr.name}}</a></th>
                        <th><i class="fa fa-check-circle text-success"></i>{{assocIrr.resourceState}}</th>
                        <th><button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#unpublishResourceModal" @click="prepareUnpublish(assocIrr)">Unpublish from this registry</button></th>
                      </tr>
                    </tbody>
                  </table>
                  <th class="pl-3" v-else>
                    This resource is not currently published in any registries.
                  </th>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow mb-4 mt-4">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h3 class="color-resource-dark mb-4">Available Registries at this Location</h3>
              </div>
              <div class="col-12">
                <div class="card">
                  <table v-if="potentialIrrs.length" class="table table-sm table-hover table-borderless" style="table-layout: fixed; width: 100%;">
                    <thead class="border-bottom">
                      <tr>
                        <th class="larger pl-3" scope="col" style="width: 33%;">Registry</th>
                        <th class="larger" scope="col" style="width: 33%;">Status</th>
                        <th class="larger" scope="col" style="width: 34%;">&nbsp;</th> <!-- Column for buttons -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="potenIrr in potentialIrrs">
                        <th class="pl-3"><a :href="'/irr/' + potenIrr.id + '/'" data-bs-toggle="tooltip" data-bs-placement="right" :title="potenIrr.description">{{potenIrr.name}}</a></th>

                        <th v-if="potenIrr.existingStatus == 'pending'"><i class="fa fa-question-circle text-info"></i>Publication request pending</th>
                        <th v-else-if="potenIrr.existingStatus == 'denied'"><i class="fa fa-times-circle text-danger"></i>Publication request denied</th>
                        <th v-else><i class="fa fa-map-marker text-secondary"></i>Publication not requested</th>

                        <!-- <th v-if="!potenIrr.userCanRequestPublish"><a :href="'/irr/' + potenIrr.id + '/requestaccess/'" class="btn btn-sm btn-info" role="button">Request contributor access to this registry</a></th> -->
                        <th v-if="potenIrr.userCanRequestPublish && (!potenIrr.existingStatus || potenIrr.existingStatus == 'denied')"><a class="btn btn-sm btn-registry" v-on:click="showModal(potenIrr)">Request to publish in this registry</a></th>
                        <th v-else>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
              </div>
              </div>
            </div>
          </div>
        </div>


        <div class="card-body">
          <div class="card-text">
            <div v-if="associatedIrrs.length + potentialIrrs.length < 1">
              <p class="lead">
                There are no registries in which you can publish this resource at this time, as there is no registry covering the location of this resource.
              </p>
              <p class="lead">
                Click below to request that we create a registry you can manage in this area. You will then be able to publish this resource in it.
              </p>
            </div>
            <p>
              <a class="btn btn-registry" href="/irr-request/create">Request a registry</a>
            </p>
          </div>
        </div>
      </div>

      <!-- Publish Modal -->
      <div class="modal fade" id="publishModal" tabindex="-1" role="dialog" aria-labelledby="publishModalLabel" aria-hidden="true" style="z-index: 10001;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="publishModalLabel">Requesting Publication</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              {{modalText.requestPublish}}
              <br>&nbsp;<br>
              <div class="checkbox">
                <label><input type="checkbox" value="" onchange="(!this.checked) ? $('#modal-publish-button').addClass('disabled') : $('#modal-publish-button').removeClass('disabled');">&nbsp;<strong>I have read, understood and agreed to the above.</strong></label>
              </div>
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
              <a :href="'/resource/' + existingData.resource.id + '/publish/' + modalIrr" class="btn btn-lg btn-registry disabled" role="button" id="modal-publish-button">Request to publish</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        csrf_token: String,
        existingData: [Object, Array],
        associatedIrrs: [Object, Array],
        potentialIrrs: [Object, Array],
        modalText: [Object, Array],
      },
      data: function () {
        return {
          modalIrr: 0,
          selectedUnpublishUrl: '',
          selectedUnpublishRegistryName: '',
        }
      },
      methods: {
        prepareUnpublish: function(unpublishIrr) {
          this.modalIrr = unpublishIrr.id;
          this.selectedUnpublishRegistryName = unpublishIrr.name || '';
          this.selectedUnpublishUrl = '/irr/' + unpublishIrr.id + '/unpublishresource/' + this.existingData.resource.id;
        },
        confirmUnpublish: function() {
          if (!this.selectedUnpublishUrl || !this.csrf_token) {
            return;
          }
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = this.selectedUnpublishUrl;
          var token = document.createElement('input');
          token.type = 'hidden';
          token.name = '_token';
          token.value = this.csrf_token;
          form.appendChild(token);
          document.body.appendChild(form);
          form.submit();
        },
        showModal: function(pubIrr) {
          this.modalIrr = pubIrr.id;
          $('#publishModal').modal('show');
        },
      },
      mounted() {
        $('#unpublishResourceModal').on('hidden.bs.modal', () => {
          this.selectedUnpublishUrl = '';
          this.selectedUnpublishRegistryName = '';
          this.modalIrr = 0;
        });
      }
    }
</script>
